import GitInfo from 'react-git-info/macro';
import devtools from 'unistore/devtools';
import { createStore } from 'unistore/full/react';
import spfetch from './spfetch';
const gitInfo = GitInfo();

const initialState = {
  activeTabIndex: 2,
  assistedCurationByPlaylistId: {},
  assistedCurationByStationId: {},
  artistsByUri: {},
  playlistsByUri: {},
  genresByUri: {},
  moodsByUri: {},
  decadesByUri: {},
  addedStateByUri: {},
  canvasesByEntityUri: {},
  contextMenuUri: null,
  contextMenuContextUri: null,
  isContextMenuOpen: false,
  isPlayerReady: false,
  colorsByUri: {},
  hubViewResponsesByUrl: {},
  featureIdentifier: gitInfo?.branch,
  internalPlayerQueue: null,
  isLoggedIn: spfetch.isLoggedIn(),
  isNowPlayingViewOpen: false,
  isPremium: null,
  isLoadingSeedOptions: false,
  hasLoadedSeedOptions: false,
  nextRows: [],
  previousRows: [],
  tracksByUri: {},
  trackRowRecommendationsByContextUri: {},
  onboardingRecs: [],
  onboardingPicks: [],
  playerQueue: null,
  playlistsById: {},
  playlists: undefined,
  preview: {},
  previewFileUriByTrackUri: {},
  searchItems: [],
  stations: [],
  stationsById: {},
  stationsByIdAndSteering: {},
  stationSeedsByStationId: {},
  adaptiveSignalByContextUriAndTrackUri: {},
  stationSearchItemsByTypeAndSearchString: {
    track: {},
    artist: {},
    playlist: {},
    genre: {},
    mood: {},
  },
  isShuffleEnabled: false,
  searchesBySectionAndString: {},
  trackFeedbackByUri: {},
  trackAppearsOnByUri: {},
};

const store =
  process.env.NODE_ENV === 'production'
    ? createStore(initialState)
    : devtools(createStore(initialState));

global.store = store;

export default store;
